import * as React from "react";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const SecurityCentre = React.lazy(() => import("./SecurityCentre"));

export default function SecurityIndex(): Array<React.ReactNode> {
    return [
        <PermissionRoute
            title="Security Centre | Shopfront"
            permissions={[ "see_security_events" ]}
            path="/security"
            key="security-centre"
            element={<SecurityCentre />}
        />,
    ];
}
